import { createServerFn } from '@tanstack/react-start'
import { env } from 'cloudflare:workers'
import type { CafeStats } from '../realtime/protocol'
import { withRegularStats } from '../realtime/regulars'

/** LP の在室人数と今日の星の数。DO が落ちていても LP は描けるよう null を返す */
export const getCafeStats = createServerFn({ method: 'GET' }).handler(async (): Promise<CafeStats | null> => {
  try {
    return withRegularStats(await env.CAFE_ROOM.get(env.CAFE_ROOM.idFromName('main')).getStats())
  } catch (e) {
    console.error('[stats] CafeRoom から取得できませんでした', e)
    return null
  }
})
